import { Button } from "@/components/ui/button";

export function PageHeader({ title, subtitle, action, testid }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4 mb-7" data-testid={testid}>
      <div>
        <h1 className="font-heading font-extrabold text-2xl sm:text-3xl tracking-tight">{title}</h1>
        {subtitle && <p className="text-muted-foreground mt-1 text-sm">{subtitle}</p>}
      </div>
      {action && <div className="flex flex-wrap items-center gap-2 shrink-0">{action}</div>}
    </div>
  );
}

export function StatCard({ icon: Icon, label, value, accent = "text-primary", testid }) {
  return (
    <div className="rounded-2xl border border-border bg-card p-5 hover:-translate-y-1 transition-transform duration-200" data-testid={testid}>
      <div className="flex items-center justify-between">
        <p className="text-xs uppercase tracking-wider text-muted-foreground font-semibold">{label}</p>
        {Icon && <Icon size={18} className={accent} />}
      </div>
      <p className="font-heading font-extrabold text-3xl mt-3">{value}</p>
    </div>
  );
}

export function EmptyState({ icon: Icon, title, desc, action, testid }) {
  return (
    <div className="rounded-2xl border border-dashed border-border bg-card/40 p-12 text-center" data-testid={testid}>
      {Icon && <Icon size={34} className="mx-auto text-muted-foreground mb-4" />}
      <p className="font-heading font-semibold text-lg">{title}</p>
      {desc && <p className="text-muted-foreground text-sm mt-1 max-w-md mx-auto">{desc}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}

export function SectionCard({ title, children, action, className = "", testid }) {
  return (
    <div className={`rounded-2xl border border-border bg-card p-4 sm:p-6 ${className}`} data-testid={testid}>
      {(title || action) && (
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-4">
          {title && <h3 className="font-heading font-semibold text-lg">{title}</h3>}
          {action && <div className="flex flex-wrap items-center gap-2">{action}</div>}
        </div>
      )}
      {children}
    </div>
  );
}

export function Loader() {
  return (
    <div className="flex justify-center py-20">
      <div className="h-8 w-8 border-2 border-primary border-t-transparent rounded-full animate-spin" />
    </div>
  );
}

export { Button };
